import Redirect from './redirect.jsx';

export default Redirect;
